import { useState } from "react";
import { Play, Loader2, Bot } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";
import { PageHeader } from "../components/common";
import { Button } from "../components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import AgentDashboard from "../components/leadgen/AgentDashboard";
import ProspectQueue from "../components/leadgen/ProspectQueue";
import AddProspects from "../components/leadgen/AddProspects";
import RunHistory from "../components/leadgen/RunHistory";
import AgentSettings from "../components/leadgen/AgentSettings";
import { useRunWatcher } from "../components/leadgen/shared";

export default function LeadAgent() {
  const [tab, setTab] = useState("dashboard");
  const [tick, setTick] = useState(0);
  const done = (run) => {
    const s = run.stats || {};
    const msg = `${s.new ?? 0} new · ${s.duplicates_blocked ?? 0} duplicates blocked · ${run.errors?.length || 0} source errors`;
    (run.status === "success" ? toast.success : run.status === "partial" ? toast.warning : toast.error)(`Run ${run.status}: ${msg}`);
    setTick((t) => t + 1);
  };
  const { running, watch } = useRunWatcher(done);
  const runNow = async () => {
    try { const r = await api.post("/leadgen/run"); toast.info("Agent run started"); watch(r.data.id); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="lead-agent-page">
      <PageHeader title={<span className="inline-flex items-center gap-2"><Bot className="h-7 w-7 text-primary" />Lead Generation Agent</span>}
        subtitle="Discovers, de-duplicates and qualifies wedding photography studios for B2B album-design outreach"
        actions={<Button className="vmw-gradient" onClick={runNow} disabled={running} data-testid="leadgen-run-now">
          {running ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Play className="h-4 w-4 mr-1" />}{running ? "Running…" : "Run Now"}</Button>} />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4 flex-wrap h-auto" data-testid="leadgen-tabs">
          <TabsTrigger value="dashboard" data-testid="leadgen-tab-dashboard">Dashboard</TabsTrigger>
          <TabsTrigger value="queue" data-testid="leadgen-tab-prospects">Prospects & Approval</TabsTrigger>
          <TabsTrigger value="add" data-testid="leadgen-tab-import">Import / Manual</TabsTrigger>
          <TabsTrigger value="history" data-testid="leadgen-tab-runs">Runs, Summary & Logs</TabsTrigger>
          <TabsTrigger value="settings" data-testid="leadgen-tab-settings">Agent Settings</TabsTrigger>
        </TabsList>
        <TabsContent value="dashboard"><AgentDashboard tick={tick} goQueue={() => setTab("queue")} /></TabsContent>
        <TabsContent value="queue"><ProspectQueue tick={tick} /></TabsContent>
        <TabsContent value="add"><AddProspects onChanged={() => setTick((t) => t + 1)} /></TabsContent>
        <TabsContent value="history"><RunHistory tick={tick} /></TabsContent>
        <TabsContent value="settings"><AgentSettings /></TabsContent>
      </Tabs>
    </div>
  );
}
